import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import appConfig from 'config/appConfig';
import getViewProperties from 'services/getViewProperties';

// Components
import SubNav from 'components/subNav';

// Styles
import styles from './header.scss';

const Header = ({ match: { params: { category = 'usdata' } } }) => {
  // Don't render if we are in a minimal view.
  const { isMinimalView } = getViewProperties(category);
  if (isMinimalView) {
    return null;
  }

  return (
    <header
      className={styles.siteHeader}
      role="banner"
    >
      <Link
        to={`/${category}`}
      >
        <h1 className={styles.siteTitle}>
          {appConfig.title[category]}
        </h1>
      </Link>
      <div>
        <SubNav />
      </div>
    </header>
  );
};

Header.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string,
    }),
  }).isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./app/components/header/index.js